export const setUnvisitedPlacesKeyword = ({ keyword }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      keyword,
      pagination: {
        ...state.unvisitedPlaces.pagination,
        currentPageNumber: 1,
        pageNumber: 1,
      },
    },
  };
};
